import React, { FunctionComponent } from 'react';
import { Accordion, AccordionDetails, Typography, Grid, AccordionSummary } from '@material-ui/core';
import styles from "../referral-ime-summary/ReferralImeSummary.Styles";
import Moment from 'moment';
import { EmptyDataLabel } from '../../../../generic-components/empty-data-label/EmptyDataLabel.Component';
import { ReferralScheduleStatusTypesEnum } from '../../../../../support/enums/ReferralScheduleStatusTypesEnum';
import { ReferralOverviewFcmDataModel } from '../../../../../data-models/ReferralOverviewFcm.DataModel';
import ReferralScheduleStatusTypeEntity from '../../../../../entities/ReferralScheduleStatusType.Entity';

interface IReferralFcmSummaryProps {
    referralOverviewFcmDataModel: ReferralOverviewFcmDataModel;
    scheduleStatusTypes: Array<ReferralScheduleStatusTypeEntity>;
    fcmRushRequest?: boolean;
}

export const ReferralFcmSummary: FunctionComponent<IReferralFcmSummaryProps> = (props: IReferralFcmSummaryProps) => {
    const classes = styles();

    const scheduleStatusTypeId = props.referralOverviewFcmDataModel?.schedule?.referralScheduleStatusTypeId;

    let claimantAttendedLabel = '';
    if (scheduleStatusTypeId === ReferralScheduleStatusTypesEnum.Completed) {
        claimantAttendedLabel = 'Yes';
    } else if (
        scheduleStatusTypeId === ReferralScheduleStatusTypesEnum.ClaimantNotAttended ||
        scheduleStatusTypeId === ReferralScheduleStatusTypesEnum.UnableToExamine
    ) {
        claimantAttendedLabel = 'No';
    }

    const getScheduleStatusLabel = (): string => {
        const statusId = props.referralOverviewFcmDataModel?.schedule?.referralScheduleStatusTypeId;
        if (!statusId || !props.scheduleStatusTypes?.length) return '';

        return props.scheduleStatusTypes
            .find(x => x.referralScheduleStatusTypeId === statusId)
            ?.referralScheduleStatusTypeLabel || '';
    };

    return (
        <Accordion defaultExpanded={true} className={classes.paper} square>
            <AccordionSummary
                aria-controls="panel1a-content"
                id="fcm-accordion"
                className={classes.paperHeader}
            >
                <Typography variant="subtitle2" className={classes.paperTitle}>FCM</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {
                    props.referralOverviewFcmDataModel ?
                        <Grid container spacing={3} className={classes.gridContainer}>
                            <Grid xs={12} item container>
                                <Grid item xs={2}>
                                    <Typography variant="body2" className={classes.dataLabel}>Schedule Status</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>
                                        {getScheduleStatusLabel()}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="body2" className={classes.dataLabel}>Schedule Date &amp; Time</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>
                                        {props.referralOverviewFcmDataModel.schedule?.scheduledDate
                                            ? Moment(props.referralOverviewFcmDataModel.schedule.scheduledDate).format('MM/DD/YYYY') + ' at ' + Moment(props.referralOverviewFcmDataModel.schedule.scheduledDate).format('HH:mm')
                                            : ''}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="body2" className={classes.dataLabel}>Claimant Verified They Will Attend</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>
                                        {props.referralOverviewFcmDataModel.schedule?.attendanceVerifiedDate
                                            ? 'Yes - ' + Moment(props.referralOverviewFcmDataModel.schedule.attendanceVerifiedDate).format('MM/DD/YYYY')
                                            : 'No'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography variant="body2" className={classes.dataLabel}>Claimant Attended</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>
                                        {claimantAttendedLabel}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography variant="body2" className={classes.dataLabel}>Rush Request</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>
                                        {props.fcmRushRequest ? 'Yes' : 'No'}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body2" className={classes.dataLabel}>Nurse Summary</Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{props.referralOverviewFcmDataModel.note?.nurseSummary}</Typography>
                            </Grid>
                        </Grid>
                        :
                        <EmptyDataLabel></EmptyDataLabel>
                }
            </AccordionDetails>
        </Accordion>
    );
};
